export default __webpack_public_path__ + "static/media/marauders-map-v3-04-01.21926194.jpg";